import { Guid, Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { BannerLocationType } from '../../shared/enums/banner-location-type';

export class PublicBannerCollectionItem {
  public constructor(
    private readonly data: {
      file: Multimedia;
      id: Guid;
      location: BannerLocationType;
      smallFile?: Nillable<Multimedia>;
      url?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get location(): BannerLocationType {
    return this.data.location;
  }

  public get file(): Multimedia {
    return this.data.file;
  }

  public get smallFile(): Nillable<Multimedia> {
    return this.data.smallFile;
  }
}
